import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '@utils/utils';
import {
    IContactLens,
    IMySavedPrescriptionItem,
    IMySavedPrescriptionsList,
} from '@interfaces/contactsInterfaces';
import { RequestStatus } from '@interfaces/mainInterfaces';

class InitialStateProps {
    // the CL in the current PDP
    currentProduct: IContactLens = null;
    addToCartRequestStatus: RequestStatus = 'IDLE';
    //MY SAVED PRESCRIPTIONS
    getMySavedPrescriptionsRequestStatus: RequestStatus = 'IDLE';
    mySavedPrescriptions: IMySavedPrescriptionsList = null;
    currentPrescription: IMySavedPrescriptionItem = null;
}

const initialState: InitialStateProps = new InitialStateProps();

const contactsReducer = (state = initialState, action): InitialStateProps => {
    switch (action.type) {
        case actionTypes.SAVE_CONTACT_LENSES_DATA:
            return updateObject(state, {
                currentProduct: action.currentProduct,
            });
        case actionTypes.ADD_TO_CART_PENDING:
            return updateObject(state, {
                addToCartRequestStatus: 'LOADING',
            });
        case actionTypes.ADD_TO_CART_SUCCESS:
            return updateObject(state, {
                addToCartRequestStatus: 'SUCCESS',
            });
        case actionTypes.ADD_TO_CART_ERROR:
            return updateObject(state, {
                addToCartRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_PENDING:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_SUCCESS:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'SUCCESS',
                mySavedPrescriptions: action.mySavedPrescriptions,
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_ERROR:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'ERROR',
            });
        case actionTypes.SET_CURRENT_PRESCRIPTION:
            return updateObject(state, {
                currentPrescription: action.currentPrescription,
            });
        default:
            return state;
    }
};

export default contactsReducer;
